/**
 * StreakRecoveryCard — when a member's streak just broke (last_active was
 * 2+ days ago), gently invite them back with a 24-hour grace window.
 * Pure client-side encouragement; the streak grace itself is enforced by
 * the bump_streak() RPC server-side.
 */
import { Flame } from "lucide-react";
import { useStreak } from "@/lib/streaks/useStreak";

const StreakRecoveryCard = () => {
  const { streak } = useStreak();
  if (!streak || !streak.last_active) return null;
  if (streak.current >= 1) return null;
  if (streak.longest < 3) return null;

  const lastDays = Math.floor(
    (Date.now() - new Date(streak.last_active).getTime()) / (24 * 60 * 60 * 1000),
  );
  if (lastDays < 1 || lastDays > 7) return null;

  return (
    <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-4 flex items-start gap-3">
      <Flame className="h-5 w-5 text-amber-500 mt-0.5 shrink-0" />
      <div className="text-sm">
        <p className="font-medium">Welcome back. Your {streak.longest}-day streak is waiting.</p>
        <p className="mt-1 text-xs text-muted-foreground">
          Open RAELA, send a Signal, or check your matches today and your streak picks back up.
        </p>
      </div>
    </div>
  );
};

export default StreakRecoveryCard;
